module.exports = __webpack_public_path__ + "static/media/bitcoin.da6de805.png";